/**
 * EL FORMULARIO DE EMITIR LLAVE: LOS ATAJOS SE SUMAN Y LA LISTA SE VE ANTES (PANEL-ATAJOS-LLAVE-T1, ASSIGN #25287/#25299).
 *
 * DE DONDE SALE. Josse, 11-oct 15:2x: "cuando presiono los permisos del mcp se borran los del tutor y viceversa". Cada
 * atajo dejaba marcados EXACTAMENTE los suyos (decision de CTX-M2-20: que el resultado no dependiera de con que llegaste).
 * Pero una llave que necesita las dos cosas -- la de Josse para ChatGPT: tutor y MCP -- no se podia armar con los atajos.
 * Ahora cada atajo SUMA a lo marcado; borrar es un boton aparte ("Limpiar permisos"), y antes de Emitir se ve la lista
 * entera de lo que se va a pedir.
 *
 * Y LA LISTA DE LLAVES. Las revocadas y vencidas ya no cargan en la vista principal: un conmutador "Ver archivadas (N)"
 * las trae. La regla de que esta viva o no la pone la vista (estadoDe), aqui solo se usa.
 *
 * Sin DOM: lo prueba scripts/check-atajos-llave.mjs.
 */

/** Lo marcado mas lo de la receta, sin repetir, en el orden en que se marcaron. */
export function sumarReceta(marcados, receta) {
  const base = Array.isArray(marcados) ? marcados.filter(Boolean) : [];
  const suma = Array.isArray(receta?.scopes) ? receta.scopes : [];
  return [...new Set([...base, ...suma])];
}

/** Cuantos permisos de la receta YA estaban marcados (para decir "agregue 4, ya tenias 0"). */
export function cuantosNuevos(marcados, receta) {
  const ya = new Set(Array.isArray(marcados) ? marcados : []);
  return (Array.isArray(receta?.scopes) ? receta.scopes : []).filter((s) => !ya.has(s)).length;
}

/** "Vas a emitir 8 permisos: a, b, ..." -- lo que de verdad se pide, antes de pedirlo. */
export function resumenDePermisos(marcados) {
  const lista = [...new Set(Array.isArray(marcados) ? marcados.filter(Boolean) : [])];
  if (!lista.length) return 'Todavia no marcaste ningun permiso.';
  return `Vas a emitir ${lista.length} ${lista.length === 1 ? 'permiso' : 'permisos'}: ${lista.join(', ')}.`;
}

/**
 * Las llaves que se pintan: por defecto solo las vivas; con verArchivadas, todas.
 * @param {object[]} creds
 * @param {boolean} verArchivadas
 * @param {(c: object) => boolean} esViva  la regla de la vista (revocada o vencida = no viva)
 * @returns {{visibles: object[], archivadas: number}}
 */
export function llavesVisibles(creds, verArchivadas, esViva) {
  const todas = Array.isArray(creds) ? creds : [];
  const archivadas = todas.filter((c) => !esViva(c)).length;
  return { visibles: verArchivadas ? todas : todas.filter((c) => esViva(c)), archivadas };
}
